import axios from "axios";
import {restApi} from "../../../constants/api";
export const login = async (mobileNo:number,password:string) => {
        const payload = {mobileNo,password};
        const response = await restApi("api/auth/login/","POST",payload,false);
        return response 
  };